/**
 * v-hasPermi 操作权限处理
 */
import store from "@/store";
import Vue from "vue";
export default {
  inserted(el, binding) {
    const { value } = binding;
    const checkPermission = () => {
      const permissions = store.state.permissions;
      if(permissions.length == 0){
        console.log("权限列表为空，等待权限列表初始化")
        return
      }
      console.log("鉴权", value, permissions);

      if (value && value instanceof Array && value.length > 0) {
        const permissionFlag = value;
        const hasPermissions = permissions.some(permission => {
          return permissionFlag.includes(permission);
        });
        if (!hasPermissions) {
          el.parentNode && el.parentNode.removeChild(el);
        }
      } else {
        throw new Error(`请设置操作权限标签值`);
      }
    };

    // 立即检查一次
    checkPermission();

    // 监听权限更新事件
    el._permCheck = checkPermission;
    Vue.prototype.$eventBus.$on("permissions-updated", el._permCheck);
  },
  unbind(el) {
    // 解绑事件监听
    Vue.prototype.$eventBus.$off("permissions-updated", el._permCheck);
    delete el._permCheck;
  }
};



// WEBPACK FOOTER //
// ./src/directive/hasPermi.js